import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const complaintCategoryList = createAsyncThunk('complaintCategory/list', async ({ navigate, type = '' }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `complaint_category`,
            params: {
                type,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const complaintCategory = createSlice({
    name: 'complaintCategory',
    initialState: {
        list: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(complaintCategoryList.pending, (state) => {
            state.loading = true
        })
        builder.addCase(complaintCategoryList.fulfilled, (state, action) => {
            state.loading = false
            if (action?.payload?.status === 200) {
                state.list = action.payload.data?.data ?? action.payload.data ?? []
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        })
        builder.addCase(complaintCategoryList.rejected, (state) => {
            state.loading = false
            state.list = []
        })
    },
})

export default complaintCategory.reducer